import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const ICON_BUTTON_CLASS_NAME = 'IconButton';
export const ICON_BUTTON_CLASS_SLOTS = ['root', 'icon'] as const;

export type IconButtonClassSlot = typeof ICON_BUTTON_CLASS_SLOTS[number];

export interface IconButtonClasses {
	/** Styles applied to the root element. */
	root: string;
	icon: string;

	default: string;

	contained: string;
	containedInherit: string;
	containedPrimary: string;
	containedSecondary: string;
	containedError: string;
	containedInfo: string;
	containedSuccess: string;
	containedWarning: string;

	fab: string;
	fabInherit: string;
	fabPrimary: string;
	fabSecondary: string;
	fabError: string;
	fabInfo: string;
	fabSuccess: string;
	fabWarning: string;

	outlined: string;
	outlinedInherit: string;
	outlinedPrimary: string;
	outlinedSecondary: string;
	outlinedError: string;
	outlinedInfo: string;
	outlinedSuccess: string;
	outlinedWarning: string;
}

export const getIconButtonUtilityClass = (slot: string) =>
	generateUtilityClass('IconButton', slot);

export const iconButtonClasses: IconButtonClasses = generateUtilityClasses(
	'IconButton',
	[
		'root',
		'default',
		'contained',
		'containedInherit',
		'containedPrimary',
		'containedSecondary',
		'containedError',
		'containedInfo',
		'containedSuccess',
		'containedWarning',
		'fab',
		'fabInherit',
		'fabPrimary',
		'fabSecondary',
		'fabError',
		'fabInfo',
		'fabSuccess',
		'fabWarning',
		'icon',
		'outlined',
		'outlinedInherit',
		'outlinedPrimary',
		'outlinedSecondary',
		'outlinedError',
		'outlinedInfo',
		'outlinedSuccess',
		'outlinedWarning',
	],
);
export default iconButtonClasses;
